import { post } from 'services/client';
import { apiEndpoints } from 'config';

export default {
  requestWineListImport: async data => {
    const options = { url: apiEndpoints.partnerUploadsRequest, data };
    return post(options);
  },
};
